import React, { createContext, useContext, useState } from 'react';

export const massActionInitialState = {
  currentStep: 0,
  massActions: [],
  availableCriterias: {},
  criteriaByKey: {},
  selectedCriterias: {},
  availableResultfields: {},
  selectedResultfields: {},
  mandatoryCriterias: [],
  currentSetupId: null,
  currentRecipeId: null,
  currentMassActionId: null,
  currentCreationDate: null,
  currentByPass: null,
  currentReplay: null,
  currentMessageId: null,
  requestModel: null,
  currentName: '',
  currentCampaignAction: null,
  currentMassActionInitialData: null,
  defaultContentFields: {},
  forbiddenContentFields: [],
  selectedDiffusionType: null,
  contentValidity: null,
  editor: null,
  objectEditor: null,
  contentHasChanges: false,
  dataLoadingChangeEventHandled: 0,
  forceIsNewContent: false,
  isWritable: true,
  commercialRelaunch: {},
};

const MassActionStateContext = createContext(null);

export const MassActionStateProvider = ({ children }) => {
  const [massActionState, setMassActionState] = useState(massActionInitialState);

  return (
    <MassActionStateContext.Provider value={{ massActionState, setMassActionState }}>
      {children}
    </MassActionStateContext.Provider>
  );
};

export const useMassActionState = () => {
  const context = useContext(MassActionStateContext);

  if (!context) {
    throw new Error('useMassActionState must be used within a MassActionStateProvider');
  }

  return [context.massActionState, context.setMassActionState];
};
